import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  Link,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaGithub, FaLinkedin, FaTelegram, FaDiscord, FaStackOverflow, FaEnvelope } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '@/utils/animation';
import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';
import { PERSONAL_INFO } from '@/constants/data';


const MotionBox = motion(Box);



export default function Contact() {
  const { ref, isVisible } = useIntersectionObserver();

  const bgGradient = useColorModeValue(
    'linear(to-b, white, gray.50)',
    'linear(to-b, gray.800, gray.900)'
  );
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  return (
    <Box
      as="section"
      py={20}
      bgGradient={bgGradient}
      id="contact"
    >
      <Container maxW="7xl">
        <VStack spacing={12}>
          <Box textAlign="center" maxW="xl" mx="auto">
            <Heading
              fontSize={{ base: '3xl', md: '4xl' }}
              fontWeight="bold"
              mb={4}
            >
              Get in Touch
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color={useColorModeValue('gray.600', 'gray.400')}
            >
              Feel free to reach out for collaborations or just a friendly hello
            </Text>
          </Box>

          <MotionBox
            ref={ref}
            mx="auto"
            w="full"
            maxW="xl"
            initial="initial"
            animate={isVisible ? 'animate' : 'initial'}
            variants={fadeInUp}
            bg={cardBg}
            p={8}
            borderRadius="xl"
            border="1px solid"
            borderColor={borderColor}
            shadow="lg"
          >
            <VStack spacing={8} align="center">
              <Text fontSize="lg" textAlign="center" maxW="2xl">
                Feel free to reach out through any of these platforms. I'll get back to you as soon as possible!
              </Text>
              
              <HStack spacing={8} justify="center" wrap="wrap">
                <Link href="https://github.com/DanishIsmail" isExternal _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaGithub} w={8} h={8} />
                    <Text>GitHub</Text>
                  </VStack>
                </Link>
                
                <Link href="https://www.linkedin.com/in/danish-gakher-769b85189" isExternal _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaLinkedin} w={8} h={8} />
                    <Text>LinkedIn</Text>
                  </VStack>
                </Link>
                
                <Link href="https://t.me/danishgakher" isExternal _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaTelegram} w={8} h={8} />
                    <Text>Telegram</Text>
                  </VStack>
                </Link>

                <Link href="https://discord.gg/danishgakher" isExternal _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaDiscord} w={8} h={8} />
                    <Text>Discord</Text>
                  </VStack>
                </Link>
                
                <Link href="https://stackoverflow.com/users/danishgakher" isExternal _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaStackOverflow} w={8} h={8} />
                    <Text>Stack Overflow</Text>
                  </VStack>
                </Link>
                
                <Link href="mailto:danish.gakher8@gmail.com" _hover={{ color: 'green.500' }}>
                  <VStack>
                    <Icon as={FaEnvelope} w={8} h={8} />
                    <Text>Email</Text>
                  </VStack>
                </Link>
              </HStack>
            </VStack>
          </MotionBox>
        </VStack>
      </Container>
    </Box>
  );
}
